import React from 'react';
import { Card, Heading, Text, Pane } from 'evergreen-ui';
import { Link as RouterLink } from 'react-router-dom';
import { formatCurrency, formatNumber } from '../../../util';

const StatsCard = ({
    formattedDashboardData,
    currentpublisher,
    getProfitLoss,
    startDate,
    endDate,
    formatCurrencyWithSymbol,
    currencySymbol
}) => {
    // Safely access stats data with validation
    const stats = formattedDashboardData?.stats || {};

    // Validate data exists before accessing
    const hasProductsSold = typeof stats.products_sold === 'number';
    const hasTopCustomers = Array.isArray(stats.top_customers) && stats.top_customers.length > 0;
    const hasTopProducts = Array.isArray(stats.top_products) && stats.top_products.length > 0;

    // Filter out empty or zero-amount expenses
    const validExpenses = Array.isArray(stats.top_expenses)
        ? stats.top_expenses.filter(expense =>
            expense && expense.category__value && expense.total_amount > 0
          )
        : [];

    return (
        <Card flex={1} padding={16} background="tint1" elevation={1}>
            <Pane display="flex" alignItems="center" marginBottom={16}>
                <Heading size={600}>Stats</Heading>
                <Text size={300} marginLeft={8} color="muted">in period</Text>
            </Pane>

            {/* Products Sold */}
            <Pane marginBottom={16}>
                <Heading size={300}>Products Sold</Heading>
                <Text fontSize={18}>{formatNumber(hasProductsSold ? stats.products_sold : 0)}</Text>
            </Pane>

            {/* Top Customers */}
            <Pane marginBottom={16}>
                <Heading size={300}>Top Customers</Heading>
                {hasTopCustomers ? (
                    stats.top_customers.map((customer, index) => (
                        <Text key={index} display="block" fontSize={14}>
                            {customer.company_name || 'Unknown'}: {formatCurrencyWithSymbol(customer.total_amount || 0)}
                        </Text>
                    ))
                ) : (
                    <Text fontSize={14} color="muted">No customer data available</Text>
                )}
            </Pane>

            {/* Top Products */}
            <Pane marginBottom={16}>
                <Heading size={300}>Top Products</Heading>
                {hasTopProducts ? (
                    stats.top_products.map((product, index) => (
                        <Text key={index} display="block" fontSize={14}>
                            <RouterLink
                                to={`/reporting/profit-loss?period=qtd&products=${product.product__id}`}
                                onClick={() => {
                                    if (currentpublisher?.id && product.product__id) {
                                        getProfitLoss({
                                            variables: {
                                                publisherId: parseInt(currentpublisher.id),
                                                productIds: [parseInt(product.product__id)],
                                                startDate,
                                                endDate
                                            },
                                            fetchPolicy: 'network-only'
                                        });
                                    }
                                }}
                                style={{ textDecoration: 'underline', color: 'inherit', cursor: 'pointer' }}
                            >
                                {product.product__title || 'Unknown Product'}
                            </RouterLink>
                            : {formatCurrencyWithSymbol(product.total_amount || 0)}
                        </Text>
                    ))
                ) : (
                    <Text fontSize={14} color="muted">No product data available</Text>
                )}
            </Pane>

            {/* Top Expense Categories */}
            <Pane>
                <Heading size={300}>Top Expense Categories</Heading>
                {validExpenses.length > 0 ? (
                    validExpenses.map((expense, index) => (
                        <Text key={index} display="block" fontSize={14}>
                            {expense.category__value || 'Uncategorized'}: {formatCurrencyWithSymbol(expense.total_amount || 0)}
                        </Text>
                    ))
                ) : (
                    <Text fontSize={14} color="muted">No expenses recorded</Text>
                )}
            </Pane>
        </Card>
    );
};

export default StatsCard;
